export default function can_use_ccm_with_map() {
  let can_use_ccm = false;
  if (window.CCM) {
    window.CCM.acceptedEmbeddings.forEach((item) => {
      if ("Google Maps" === item.name) {
        can_use_ccm = true;
      }
    });
  }

  return can_use_ccm;
}



// WEBPACK FOOTER //
// ./src/check-ccm.js